import { plural, t } from '@lingui/macro'
import {
  CampaignFilter,
  TimeDurationUnitsEnum,
  TemporalDirection
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import dayjs from 'shared/dayjs'

const getTimeDurationUnitUI = (count: number, unit: TimeDurationUnitsEnum) => {
  switch (unit) {
    case TimeDurationUnitsEnum.DAY:
      return plural(count, {
        one: 'day',
        other: 'days'
      })
    case TimeDurationUnitsEnum.MONTH:
      return plural(count, {
        one: 'month',
        other: 'months'
      })
    case TimeDurationUnitsEnum.HOUR:
      return plural(count, {
        one: 'hour',
        other: 'hours'
      })

    case TimeDurationUnitsEnum.WEEK:
      return plural(count, {
        one: 'week',
        other: 'weeks'
      })
    case TimeDurationUnitsEnum.YEAR:
      return plural(count, {
        one: 'year',
        other: 'years'
      })
  }
}

export const getFilterTimeFrame = (filter: CampaignFilter) => {
  let timeFrame
  if (filter.temporalComparator) {
    if (filter.temporalComparator.relative) {
      const unit = filter.temporalComparator.relative.duration
        ?.unit as TimeDurationUnitsEnum
      const multiplier = filter.temporalComparator.relative.duration
        ?.multiplier as number
      timeFrame = ` ${
        filter.temporalComparator.relative.direction ===
        TemporalDirection.BEFORE
          ? t`for more than`
          : t`in less than`
      } ${multiplier} ${getTimeDurationUnitUI(multiplier, unit)}`
    } else if (filter.temporalComparator.static) {
      timeFrame = ` ${
        filter.temporalComparator.static.direction === TemporalDirection.BEFORE
          ? t`before`
          : t`after`
      } ${dayjs(
        new Date(filter.temporalComparator.static.date as string)
      ).format('L')}`
    } else if (filter.temporalComparator.range) {
      timeFrame = ` from ${dayjs(
        new Date(filter.temporalComparator.range.fromDate as string)
      ).format('L')} to ${dayjs(
        new Date(filter.temporalComparator.range.toDate as string)
      ).format('L')}`
    }
  }
  return timeFrame
}
